import { BarChart } from '@mantine/charts'
import { useMediaQuery } from '@mantine/hooks'
import { FULL_MONTH } from '../months'

type WaterfallChartProps = {
  data: Array<{ label: string; value: number | null | undefined }>
  valueLabel: string
  normalBarChart?: boolean
}

export default function WaterfallChart(props: WaterfallChartProps) {
  const isDesktop = useMediaQuery('(min-width: 800px)')
  const data = props.data.map(({ label, value }) => ({
    [props.valueLabel]: value,
    label,
  }))
  return (
    <BarChart
      styles={{
        tooltip: {
          backgroundColor: 'light-dark(white, var(--mantine-color-gray-9)',
        },
      }}
      h="100%"
      w="100%"
      data={data}
      getBarColor={(value) => (value > 0 ? 'teal.7' : 'red.7')}
      dataKey="label"
      series={[{ name: props.valueLabel, color: 'gray' }]}
      yAxisProps={{
        domain: ([dataMin, dataMax]) => {
          if (props.normalBarChart) {
            return [0, dataMax * 2]
          }
          const absMax =
            Math.ceil(Math.max(Math.abs(dataMin), Math.abs(dataMax)) * 10) / 10
          return [-absMax, absMax]
        },
        tickFormatter: (value) =>
          value === 0
            ? '100%'
            : `${value > 0 ? '+' : ''}${(100 * value).toFixed(1)}%`,
      }}
      valueFormatter={(value) =>
        `${value > 0 ? '+' : ''}${(100 * value).toFixed(1)}%`
      }
      barChartProps={{}}
      barProps={{ barSize: 16 }}
      xAxisProps={{
        tickFormatter: (label: string) => (isDesktop ? label : label[0]),
      }}
      tooltipProps={{
        labelFormatter: (label: string) => FULL_MONTH[label] || label,
      }}
    />
  )
}
